// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { AssetInfoFragmentDoc } from '../../assets/AssetPreview.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type SaveHomeownerNoteMutationVariables = Types.Exact<{
  input: Types.SaveHomeownerNoteInput;
}>;


export type SaveHomeownerNoteMutation = { __typename?: 'Mutation', saveHomeownerNote: { __typename?: 'SaveHomeownerNoteResult', homeownerNote: { __typename?: 'HomeownerNote', id: string, title: string, description: string } } };

export type DeleteHomeownerNoteMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type DeleteHomeownerNoteMutation = { __typename?: 'Mutation', deleteHomeownerNote?: { __typename?: 'EmptyResult', emptyResult?: string | null | undefined } | null | undefined };

export type EditHomeownerNoteQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type EditHomeownerNoteQuery = { __typename?: 'Query', homeownerNote: { __typename?: 'HomeownerNote', id: string, title: string, description: string, jobLogImages: Array<{ __typename?: 'JobLogImage', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined } }> } };

export type ScheduleTasksForHomeownerNoteQueryVariables = Types.Exact<{
  project?: Types.InputMaybe<Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']>;
}>;


export type ScheduleTasksForHomeownerNoteQuery = { __typename?: 'Query', scheduleTasks: Array<{ __typename?: 'ScheduleTask', id: string, name: string, homeownerDescription?: string | null | undefined, status: Types.TaskStatus, interval: { __typename?: 'CalendarInterval', startDate: Types.Scalars['Date']['input'], endDate: Types.Scalars['Date']['input'] } }> };

export type EditHomeownerNoteFragment = { __typename?: 'HomeownerNote', id: string, title: string, description: string, jobLogImages: Array<{ __typename?: 'JobLogImage', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined } }> };

export type HomeownerNoteScheduleTaskFragment = { __typename?: 'ScheduleTask', id: string, name: string, homeownerDescription?: string | null | undefined, status: Types.TaskStatus, interval: { __typename?: 'CalendarInterval', startDate: Types.Scalars['Date']['input'], endDate: Types.Scalars['Date']['input'] } };

export const EditHomeownerNoteFragmentDoc = gql`
    fragment EditHomeownerNote on HomeownerNote {
  id
  title
  description
  jobLogImages {
    id
    asset {
      ...AssetInfo
    }
  }
}
    ${AssetInfoFragmentDoc}`;
export const HomeownerNoteScheduleTaskFragmentDoc = gql`
    fragment HomeownerNoteScheduleTask on ScheduleTask {
  id
  name
  homeownerDescription
  status
  interval {
    startDate
    endDate
  }
}
    `;
export const SaveHomeownerNoteDocument = gql`
    mutation SaveHomeownerNote($input: SaveHomeownerNoteInput!) {
  saveHomeownerNote(input: $input) {
    homeownerNote {
      id
      title
      description
    }
  }
}
    `;
export type SaveHomeownerNoteMutationFn = Apollo.MutationFunction<SaveHomeownerNoteMutation, SaveHomeownerNoteMutationVariables>;

/**
 * __useSaveHomeownerNoteMutation__
 *
 * To run a mutation, you first call `useSaveHomeownerNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveHomeownerNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveHomeownerNoteMutation, { data, loading, error }] = useSaveHomeownerNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveHomeownerNoteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveHomeownerNoteMutation, SaveHomeownerNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveHomeownerNoteMutation, SaveHomeownerNoteMutationVariables>(SaveHomeownerNoteDocument, options);
      }
export type SaveHomeownerNoteMutationHookResult = ReturnType<typeof useSaveHomeownerNoteMutation>;
export type SaveHomeownerNoteMutationResult = Apollo.MutationResult<SaveHomeownerNoteMutation>;
export type SaveHomeownerNoteMutationOptions = Apollo.BaseMutationOptions<SaveHomeownerNoteMutation, SaveHomeownerNoteMutationVariables>;
export const DeleteHomeownerNoteDocument = gql`
    mutation DeleteHomeownerNote($id: ID!) {
  deleteHomeownerNote(input: {id: $id}) {
    emptyResult
  }
}
    `;
export type DeleteHomeownerNoteMutationFn = Apollo.MutationFunction<DeleteHomeownerNoteMutation, DeleteHomeownerNoteMutationVariables>;

/**
 * __useDeleteHomeownerNoteMutation__
 *
 * To run a mutation, you first call `useDeleteHomeownerNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteHomeownerNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteHomeownerNoteMutation, { data, loading, error }] = useDeleteHomeownerNoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteHomeownerNoteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteHomeownerNoteMutation, DeleteHomeownerNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteHomeownerNoteMutation, DeleteHomeownerNoteMutationVariables>(DeleteHomeownerNoteDocument, options);
      }
export type DeleteHomeownerNoteMutationHookResult = ReturnType<typeof useDeleteHomeownerNoteMutation>;
export type DeleteHomeownerNoteMutationResult = Apollo.MutationResult<DeleteHomeownerNoteMutation>;
export type DeleteHomeownerNoteMutationOptions = Apollo.BaseMutationOptions<DeleteHomeownerNoteMutation, DeleteHomeownerNoteMutationVariables>;
export const EditHomeownerNoteDocument = gql`
    query EditHomeownerNote($id: ID!) {
  homeownerNote(id: $id) {
    ...EditHomeownerNote
  }
}
    ${EditHomeownerNoteFragmentDoc}`;

/**
 * __useEditHomeownerNoteQuery__
 *
 * To run a query within a React component, call `useEditHomeownerNoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditHomeownerNoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditHomeownerNoteQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEditHomeownerNoteQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EditHomeownerNoteQuery, EditHomeownerNoteQueryVariables> & ({ variables: EditHomeownerNoteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EditHomeownerNoteQuery, EditHomeownerNoteQueryVariables>(EditHomeownerNoteDocument, options);
      }
export function useEditHomeownerNoteLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EditHomeownerNoteQuery, EditHomeownerNoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EditHomeownerNoteQuery, EditHomeownerNoteQueryVariables>(EditHomeownerNoteDocument, options);
        }
export function useEditHomeownerNoteSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EditHomeownerNoteQuery, EditHomeownerNoteQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EditHomeownerNoteQuery, EditHomeownerNoteQueryVariables>(EditHomeownerNoteDocument, options);
        }
export type EditHomeownerNoteQueryHookResult = ReturnType<typeof useEditHomeownerNoteQuery>;
export type EditHomeownerNoteLazyQueryHookResult = ReturnType<typeof useEditHomeownerNoteLazyQuery>;
export type EditHomeownerNoteSuspenseQueryHookResult = ReturnType<typeof useEditHomeownerNoteSuspenseQuery>;
export type EditHomeownerNoteQueryResult = Apollo.QueryResult<EditHomeownerNoteQuery, EditHomeownerNoteQueryVariables>;
export const ScheduleTasksForHomeownerNoteDocument = gql`
    query ScheduleTasksForHomeownerNote($project: [ID!]) {
  scheduleTasks(
    filter: {project: $project, stage: [CONSTRUCTION], homeownerVisible: true}
    first: 5000
  ) {
    ...HomeownerNoteScheduleTask
  }
}
    ${HomeownerNoteScheduleTaskFragmentDoc}`;

/**
 * __useScheduleTasksForHomeownerNoteQuery__
 *
 * To run a query within a React component, call `useScheduleTasksForHomeownerNoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduleTasksForHomeownerNoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduleTasksForHomeownerNoteQuery({
 *   variables: {
 *      project: // value for 'project'
 *   },
 * });
 */
export function useScheduleTasksForHomeownerNoteQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ScheduleTasksForHomeownerNoteQuery, ScheduleTasksForHomeownerNoteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ScheduleTasksForHomeownerNoteQuery, ScheduleTasksForHomeownerNoteQueryVariables>(ScheduleTasksForHomeownerNoteDocument, options);
      }
export function useScheduleTasksForHomeownerNoteLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ScheduleTasksForHomeownerNoteQuery, ScheduleTasksForHomeownerNoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ScheduleTasksForHomeownerNoteQuery, ScheduleTasksForHomeownerNoteQueryVariables>(ScheduleTasksForHomeownerNoteDocument, options);
        }
export function useScheduleTasksForHomeownerNoteSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ScheduleTasksForHomeownerNoteQuery, ScheduleTasksForHomeownerNoteQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ScheduleTasksForHomeownerNoteQuery, ScheduleTasksForHomeownerNoteQueryVariables>(ScheduleTasksForHomeownerNoteDocument, options);
        }
export type ScheduleTasksForHomeownerNoteQueryHookResult = ReturnType<typeof useScheduleTasksForHomeownerNoteQuery>;
export type ScheduleTasksForHomeownerNoteLazyQueryHookResult = ReturnType<typeof useScheduleTasksForHomeownerNoteLazyQuery>;
export type ScheduleTasksForHomeownerNoteSuspenseQueryHookResult = ReturnType<typeof useScheduleTasksForHomeownerNoteSuspenseQuery>;
export type ScheduleTasksForHomeownerNoteQueryResult = Apollo.QueryResult<ScheduleTasksForHomeownerNoteQuery, ScheduleTasksForHomeownerNoteQueryVariables>;